module.exports = __webpack_public_path__ + "static/media/19ESCAP5.767299d2.jpg";